import { useCallback } from 'react';

import { useToast } from '@ecoinvent/ui';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useQueryErrorEffect from 'hooks/useQueryErrorEffect';
import useVersionInfo from 'hooks/useVersionInfo';

import { FetchV4IndicatorsParams, V4IndicatorTree } from './types';

const fetchV4Indicators = async (params: FetchV4IndicatorsParams) => {
  const { data } = await api.get(`/web/v4/indicators`, { params });

  return data;
};

const useV4Indicators = () => {
  const toast = useToast();

  const { ver: version, system_model } = useVersionInfo();
  const queryKey = ['v4indicators', version, system_model];
  const query = useQuery<V4IndicatorTree, AxiosError>({
    queryKey,
    queryFn: () => fetchV4Indicators({ version, system_model }),
    retry: false,
    staleTime: Infinity,
  });

  const showError = useCallback(() => {
    toast({
      title: 'Oh no...',
      description: 'There was an error loading the LCIA indicators. Please try again later.',
      status: 'error',
      isClosable: true,
    });
  }, [toast]);
  useQueryErrorEffect(query, queryKey, showError);

  return query;
};

export default useV4Indicators;
